export default {
  createHotelSuccess: 'You have successfully added a hotel!',
  createHotelFailure: 'Error: Something went wrong. Please try again.',
  getHotelsSuccess: 'Here are the hotels you have so far!',
  getHotelsFailure: 'Error: Something went wrong. Please try again.',
  showHotelSuccess: 'Here\'s your hotel!',
  showHotelFailure: 'Error: Something went wrong. Please try again.',
  updateHotelSuccess: 'You have successfully edited your hotel!',
  updateHotelFailure: 'Error: Something went wrong. Please try again.',
  deleteHotelSuccess: 'You have successfully deleted your hotel!',
  deleteHotelFailure: 'Error: Something went wrong. Please try again.',
}



// WEBPACK FOOTER //
// ./src/hotels/messages.js